import PropTypes from 'prop-types'
import React from 'react'
import CSSModules from 'react-css-modules'

import styles from './tooltip_content.scss'
import classNames from 'classnames'

const TooltipContent = props => (
	<div
		styleName={classNames({
			'tooltip-content': true,
			['tooltip-content--single-line']: props.withSingleLine,
		})}
	>
		<p styleName='tooltip-content-title'>
			{props.mainText}
		</p>
	</div>
)

TooltipContent.propTypes = {
	mainText: PropTypes.string,
	withSingleLine: PropTypes.bool,
}

TooltipContent.defaultProps = {
	mainText: '',
	withSingleLine: true,
}

export default CSSModules(TooltipContent, styles, {allowMultiple: true})
